import {
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
  RESET_RESET_PASSWORD_STATE,
} from "../../actionTypes/resetPassword";

export interface ResetPasswordState {
  loading: boolean;
  data: string;
  error: string | null;
  success: boolean;
}

export interface ResetPasswordAction {
  type: string;
  payload: string;
}

const initialState: ResetPasswordState = {
  loading: false,
  data: "",
  error: null,
  success: false,
};

const resetPassword = (
  state = initialState,
  action: ResetPasswordAction,
): ResetPasswordState => {
  switch (action.type) {
    case RESET_PASSWORD_REQUEST:
      return { ...state, loading: true, error: null };
    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        success: true,
        error: null,
      };
    case RESET_PASSWORD_FAILURE:
      return { ...state, loading: false, error: action.payload || null };
    case RESET_RESET_PASSWORD_STATE:
      return initialState;
    default:
      return state;
  }
};

export default resetPassword;
